import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem('cookie-consent');
    if (!hasConsent) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setShow(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie-consent', 'rejected');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-foreground text-background p-6 md:p-8 border-t border-background/20">
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex-1">
          <h3 className="font-serif text-lg font-medium mb-2">Personvern og informasjonskapsler</h3>
          <p className="text-sm text-background/80">
            Vi bruker informasjonskapsler for å forbedre din opplevelse på vår nettside. Ved å godta, samtykker du til vår bruk av informasjonskapsler og vår{' '}
            <Link to="/privacy-policy" className="underline hover:opacity-80 transition-opacity">
              privatlivspolicy
            </Link>
            .
          </p>
        </div>

        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={handleReject}
            className="px-4 py-2 border border-background/40 text-background text-sm font-sans uppercase tracking-widest hover:bg-background/10 transition-colors rounded-sm"
          >
            Avvis
          </button>
          <button
            onClick={handleAccept}
            className="px-6 py-2 bg-background text-foreground text-sm font-sans uppercase tracking-widest hover:bg-background/90 transition-colors rounded-sm"
          >
            Godta alt
          </button>
        </div>

        <button
          onClick={handleReject}
          aria-label="Lukk informasjonskapsler"
          className="absolute top-4 right-4 md:hidden"
        >
          <X size={20} className="text-background" />
        </button>
      </div>
    </div>
  );
}